import { Component, OnInit, Input } from '@angular/core';
import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { GovPayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/govpay/govpay-payment-processor-account-configuration';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'wm-payment-account-config-govpay',
    templateUrl: './payment-account-config-govpay.component.html',
    styleUrls: ['./payment-account-config-govpay.component.css'],
    standalone: false
})
export class PaymentAccountConfigGovPayComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {
  @Input() config: GovPayPaymentProcessorAccountConfiguration;

  constructor(fb: UntypedFormBuilder) {
    super(fb);
    this.showUsername = false;
    this.showPassword = false;
  }

  ngOnInit() {
    this.addValidation('partnerId', Validators.required, this.config.partnerId);
  }
}
